import { ReactSVG } from 'react-svg';
import styled from 'styled-components';

export const DetailsTableWrapper = styled.div`
  margin: 10px 15px;
  overflow-y: auto;

  table {
    width: 100%;
    tbody {
      max-height: 300px;
    }
  }
`;